import { getUserAvailableBonuses } from "@actions/bonus";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { connect } from "react-redux";
import {
	Box,
	BoxTitle,
	Content,
	FailureImg,
	MaskedInput,
	ResultContent,
	ResultText,
	SuccessImg,
} from "../baseItems";
import Base from "./base";

class Penapay extends Base {
	componentDidMount() {
		this.props.getUserAvailableBonuses(
			{ params: { size: 15, offset: this.props.offsetToken } },
			() => {}
		);
	}

	onSelectBonus(e) {
		if (e.target.value != "No Bonus") {
			const { bonusList } = this.props;
			const selectedBonus = bonusList.filter((item) => item.name == e.target.value);
			this.setState({
				claimsBonus: true,
				bonusId: selectedBonus[0].id,
			});
		} else {
			this.setState({
				claimsBonus: false,
				bonusId: "",
			});
		}
	}

	onEnterValue(name, e) {
		let v = e.target.value,
			newState = { ...this.state };
		newState[name] = v;
		this.setState(newState);
	}

	onFinish() {
		//check values is valid
		//TODO: regex check for credit card
		let card_number = this.state.card_number.replaceAll("/", "");
		const { claimsBonus, stake, bonusId } = this.state;
		this.props.externalFunc.depositPenapay(
			{
				bonusId,
				claimsBonus,
				card_number,
				amount: parseInt(stake),
				language: this.getActiveLanguageCode(),
			},
			(data) => {
				this.setState({
					showSuccessWindow: data.code === "OK",
					showFailWindow: data.code === "FAILED",
				});
			},
			() => {
				this.setState({
					showFailWindow: true,
					showSuccessWindow: false,
				});
			}
		);
	}

	getStep3(translate) {
		const { selectedDeposit } = this.props,
			{ stake, showFailWindow, showSuccessWindow } = this.state;
		return (
			<Fragment>
				{showSuccessWindow && (
					<Content>
						<ResultContent>
							<SuccessImg></SuccessImg>
							<ResultText>{translate("PAYMENT_APPROVED")}</ResultText>
						</ResultContent>
					</Content>
				)}
				{showFailWindow && (
					<Content>
						<ResultContent>
							<FailureImg></FailureImg>
							<ResultText>{translate("PAYMENT_REJECTED")}</ResultText>
						</ResultContent>
					</Content>
				)}
				{!showFailWindow && !showSuccessWindow && (
					<Content>
						<Box small={true}>
							<BoxTitle>{translate("CREDIT_CARD")}</BoxTitle>
							<MaskedInput>
								<MaskInput
									data-testid="input-deposit-credit-card"
									alwaysShowMask={window.IS_MARS ? true : false}
									maskChar="."
									mask="0000/0000/0000/0000"
									onChange={this.onEnterValue.bind(this, "card_number")}
								/>
							</MaskedInput>
						</Box>
					</Content>
				)}
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	bonusList: state.bonus.userAvailableBonuses,
	offsetToken: state.bonus.userAvailableBonusesOffset,
	listEnd: state.bonus.listEnd,
});

const mapDispatchToProps = {
	getUserAvailableBonuses,
};

export default connect(mapStateToProps, mapDispatchToProps)(Penapay);
